import React from 'react';

interface Props {
  page: number;
  pages: number;
  total: number;
  perPage: number;
  onPage: (p: number) => void;
}

function pageNumbers(page: number, pages: number): (number | '...')[] {
  if (pages <= 7) return Array.from({ length: pages }, (_, i) => i + 1);
  const nums: (number | '...')[] = [1];
  const start = Math.max(2, page - 2);
  const end = Math.min(pages - 1, page + 2);
  if (start > 2) nums.push('...');
  for (let i = start; i <= end; i++) nums.push(i);
  if (end < pages - 1) nums.push('...');
  nums.push(pages);
  return nums;
}

export default function Pagination({ page, pages, total, perPage, onPage }: Props) {
  const from = (page - 1) * perPage + 1;
  const to = Math.min(page * perPage, total);

  return (
    <div className="pagination">
      <span className="pagination-info">
        {from.toLocaleString()}–{to.toLocaleString()} of {total.toLocaleString()}
      </span>
      <div className="pagination-controls">
        <button className="page-btn" disabled={page <= 1} onClick={() => onPage(page - 1)}>‹</button>
        {pageNumbers(page, pages).map((p, i) =>
          p === '...' ? (
            <span key={`dot-${i}`} style={{ padding: '0 2px', color: 'var(--tx3)', fontSize: 13 }}>…</span>
          ) : (
            <button
              key={p}
              className={`page-btn${p === page ? ' active' : ''}`}
              onClick={() => onPage(p as number)}
            >
              {p}
            </button>
          )
        )}
        <button className="page-btn" disabled={page >= pages} onClick={() => onPage(page + 1)}>›</button>
      </div>
    </div>
  );
}
